import React, { Fragment } from 'react';
import { Intro, Video } from 'dea-core';
// import video from '../../assets/videos/DEA_OPW_M01_08.mp4';
import transcript from '../../assets/videos/DEA_OPW_M01_08-NEW.vtt';
// import poster from '../../assets/videos/';

const videoFiles = {
  sources: [
    {
      src:
        'https://operationprevention.com/sites/default/files/SPM_videos/module_1/DEA_OPW_M01_08-NEW.mp4'
    }
  ],
  tracks: [
    {
      src: transcript,
      kind: 'captions',
      label: 'English'
    }
  ],
  poster: ''
};

export default {
  title: 'The Problematic Nature of Illicit Fentanyl',
  path: '/elaborate/problematic-nature-of-illicit-fentanyl',
  content: (
    <Fragment>
      <Intro
        title="Gail on how illicit fentanyl has led to an increase in overdoses."
        lead="Gail explains how illicit fentanyl has led to an increase in street drug overdoses…"
        direction={'Select the play button below to begin.'}
      />
      <Video videoFiles={videoFiles} />
    </Fragment>
  )
};



// WEBPACK FOOTER //
// ./src/data/elaborate/ProblematicNatureOfIllicitFentanyl.js